import * as React from 'react';
import Modal from '@mui/material/Modal';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import baseUrlApi from '../../../lib/baseUrlApi';
import {ApiRequest} from "../../../Consts/ApiRequest";
import { modalProps } from '../../../Consts/constants';

type MailAdminInputs = {
  mailAddress1: string;
  mailAddress2: string;
  mailAddress3: string;
  mailAddress4: string;
  mailAddress5: string;
};

export default function MailModal() {
  const [open, setOpen] = React.useState(false);
  const [mailAdminData, setMailAdminData] = useState<MailAdminInputs[]>([]);
  const [mailAddress1, setMailAddress1] = useState<string>("");
  const [mailAddress2, setMailAddress2] = useState<string>("");
  const [mailAddress3, setMailAddress3] = useState<string>("");
  const [mailAddress4, setMailAddress4] = useState<string>("");
  const [mailAddress5, setMailAddress5] = useState<string>("");
  const [error, setError] = useState<string[]>([]);

  // クッキーに保存されたトークンを定数に格納
  const { register, reset, handleSubmit, formState: { errors } } = useForm<MailAdminInputs>();
  const mailAddresses = [mailAddress1, mailAddress2, mailAddress3, mailAddress4, mailAddress5].filter(Boolean);
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
  const resetData = async() => {
    setMailAdminData([]);
    setError([]);
    await fetchMailAddresses();
  }

  const fetchMailAddresses = async () => {
    const token = cookies.access_token || "";
    ApiRequest.getMailAddress({}, token,
        (response :any)=>{
          setMailAddress1(response.data.mailAddresses?.[0] || "");
          setMailAddress2(response.data.mailAddresses?.[1] || "");
          setMailAddress3(response.data.mailAddresses?.[2] || "");
          setMailAddress4(response.data.mailAddresses?.[3] || "");
          setMailAddress5(response.data.mailAddresses?.[4] || "");
        }, (error:any)=>{
          console.error("Error fetching data:", error);
          errorCallback(error);
        })
  }

  const handleOpen = async() => {
    await resetData();
    setOpen(true);
  }

  const handleClose = async() => {
    await resetData();
    setOpen(false);
  }

  function errorCallback(error:any){
    if (error.response && error.response.status === 401) {
      console.error("Error token error:", error);
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
    }
    console.error("Error fetching dataSite:", error);
  }

  useEffect(() => {
    const token = cookies.access_token || "";
    console.log("...............");
    ApiRequest.getMailAddress({}, token,
        (response :any)=>{
          setMailAddress1(response.data.mailAddresses?.[0] || "");
          setMailAddress2(response.data.mailAddresses?.[1] || "");
          setMailAddress3(response.data.mailAddresses?.[2] || "");
          setMailAddress4(response.data.mailAddresses?.[3] || "");
          setMailAddress5(response.data.mailAddresses?.[4] || "");
        }, (error:any)=>{
          console.error("Error fetching data:", error);
          errorCallback(error);
        })
}, []);

const onSubmit: SubmitHandler<MailAdminInputs> = async (data) => {
  try {
      const token = cookies.access_token || "";
      let params = {
          mailAddresses: mailAddresses
      };
      await ApiRequest.registMailAddress(params, token, (response: any) => {
          console.log(response);
          if (Array.isArray(response.data)) {
              setMailAdminData(response.data);
          }
          setError(response.data.messsages);
          if (response.data.result === 0) {
              handleClose();
          }
      }, (error: any) => {
          errorCallback(error);
      });
  } catch (error) {
    console.error("Error fetching data:", error);
    alert("エラーが発生しました");
  }
};

return (
  <div>
    <button onClick={handleOpen} className="btn btn-blue-line"><i className="icon-setting-b"></i>メールアドレス設定</button>
    <Modal {...modalProps} open={open}>
      <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
        <div className="modal">
          <div className="modal-header">
            <div className="modal-title">
              メールアドレス設定
            </div>
            <a onClick={handleClose} className="modal-close"></a>
          </div>
          <div className="modal-body">
            <div className="edit-box">
              {
                (error.length > 0) ?
                  <ul className="error-box">
                    {error.map((item, index) => (
                            <li>{item}</li>
                     ))}
                  </ul>
                  : null
              }
              <div className="edit-box-elm">
                <div className="edit-box-elm-name">メールアドレス１</div>
                <div className="edit-box-elm-input">
                  <input
                    type="text"
                    name={"mail1"}
                    autoComplete={Math.random().toString(32).substring(2) }
                    defaultValue={mailAddress1}
                    placeholder="メールアドレス１"
                    onChange={(e) => setMailAddress1(e.target.value)}
                  />
                </div>
              </div>
              <div className="edit-box-elm">
                <div className="edit-box-elm-name">メールアドレス２</div>
                <div className="edit-box-elm-input">
                  <input
                    type="text"
                    name={"mail2"}
                    autoComplete={Math.random().toString(32).substring(2) }
                    defaultValue={mailAddress2}
                    placeholder="メールアドレス２"
                    onChange={(e) => setMailAddress2(e.target.value)}
                  />
                </div>
              </div>
              <div className="edit-box-elm">
                <div className="edit-box-elm-name">メールアドレス３</div>
                <div className="edit-box-elm-input col-320">
                  <input
                    type="text"
                    name={"mail3"}
                    autoComplete={Math.random().toString(32).substring(2) }
                    defaultValue={mailAddress3}
                    placeholder="メールアドレス３"
                    onChange={(e) => setMailAddress3(e.target.value)}
                  />
                </div>
              </div>
              <div className="edit-box-elm">
                <div className="edit-box-elm-name">メールアドレス４</div>
                <div className="edit-box-elm-input col-320">
                  <input
                    type="text"
                    name={"mail4"}
                    autoComplete={Math.random().toString(32).substring(2) }
                    value={mailAddress4}
                    placeholder="メールアドレス４"
                    onChange={(e) => setMailAddress4(e.target.value)}
                  />
                </div>
              </div>
              <div className="edit-box-elm">
                <div className="edit-box-elm-name">メールアドレス５</div>
                <div className="edit-box-elm-input col-320">
                  <input
                    type="text"
                    name={"mail5"}
                    autoComplete={Math.random().toString(32).substring(2) }
                    defaultValue={mailAddress5}
                    placeholder="メールアドレス５"
                    onChange={(e) => setMailAddress5(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <div className="model-action-sub">
            </div>
            <div className="model-action-main">
              <button className="btn btn-blue-line">
                <a onClick={handleClose} className="">
                  キャンセル
                </a>
              </button>
              <form onSubmit={handleSubmit(onSubmit)}>
                <button className="btn btn-blue col-160">
                  <i className="icon-check-w"></i>確定
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
);
}
